var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"r-circle-block",style:(_vm.getStyle())},[_c('div',{staticClass:"r-circle-block__header"},[_vm._t("header")],2),_c('div',{staticClass:"r-circle-block__main"},[_vm._t("default")],2),_c('div',{staticClass:"r-circle-block__footer"},[_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }